import setFilters from 'store/reducer-utils/setFilters'
import { DROP_DATA, SET_CATEGORIES, SET_FILTERS, SET_LOADING } from 'modules/AccountsMarketplace/Categories/types'
import { updateObject } from 'utils/updateObject'

const initialState = {
  loading: true,
  filters: null,
  data: [],
}

const setLoading = (state, { payload }) => updateObject(state, { payload })

const accountsMarketplaceSetFilter = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const setCategories = (state, { payload }) =>
  updateObject(state, {
    data: [...state.data, ...payload],
    loading: false,
  })

const dropData = (state) => updateObject(state, { data: [], loading: true })

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return setLoading(state, action)
    case SET_FILTERS:
      return accountsMarketplaceSetFilter(state, action)
    case SET_CATEGORIES:
      return setCategories(state, action)
    case DROP_DATA:
      return dropData(state)
    default:
      return state
  }
}
